export default __webpack_public_path__ + "static/media/topbar-icon-avianpay.50307908.svg";